<template>
  <div id="pageContent">
    <div class="join-page">
      <!--상단-->
      <ul class="top-info">
        <li class="logo-img">
          <img src="@/assets/img/dragons_logo.png" alt="dragons_logo">
        </li>
        <li class="logo-text">
          <img src="@/assets/img/logo_text.png" alt="logo_text">
        </li>
        <li class="text">
          <p class="title">MEMBERSHIP JOIN</p>
          <p v-if="processActive === 1">회원가입을 위해서 아래 약관에 동의하셔야 합니다.</p>
          <p v-if="processActive === 2">전남드래곤즈 회원가입을 위해 본인인증이 필요합니다.</p>
          <p v-if="processActive === 3">전남드래곤즈 회원가입을 위해 양식을 입력하세요.</p>
        </li>
      </ul>
      <!--프로세스-->
      <div class="process-all">
        <ul v-for="(item, index) in process" :key="index" class="process-div">
          <li :class="{active: item.num === currentMenu}">
            <div class="num">0{{item.num}}</div>
            <p>{{item.text}}</p>
          </li>
          <li v-if="process.length !== index+1" class="line">
          </li>
        </ul>
      </div>
      <router-view class="contents"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Join',
  data() {
    return {
      processActive: 3,
      process: [
        {
          num: 1,
          text: '약관동의',
        }, {
          num: 2,
          text: '본인인증',
        }, {
          num: 3,
          text: '회원가입',
        }
      ]
    }
  },
  mounted () {
  },
  computed: {
    currentMenu() {
      switch (this.$route.name) {
        case 'agree' :
          return 1;
        case 'citation' :
          return 2;
        case 'form' :
          return 3;
        default :
          return 0;
      }
    }
  }
}
</script>
